import Client from '../Client';
import AccountingStat from "../../models/AccountingStat";
import RestClient from "./RestClient";
import * as _ from 'es-toolkit';

class AccountingStats extends RestClient {
    constructor() {
        super({
            "model": AccountingStat,
            "entryPoint": "accountings",
            "resource": "accounting",
            "resources": "accountings",
            "id_field": "_id"
        });

        this.client = new Client();
    }

    /**
     * Get sales statistics
     * @param {Object} params - Query parameters
     * @returns {Promise} - API response
     */
    getStats(params) {
        // remove empty filter values
        params = _.pickBy(params, _.identity);

        return this.client.GET('/accountings/stats', params)
            .then(async response => {
                if (!response.ok) {
                    throw new Error(`Failed to load accounting stats (${response.status})`);
                }

                try {
                    return await response.json();
                } catch (error) {
                    throw new Error('Invalid accounting stats response payload');
                }
            })
            .catch(error => {
                if (error instanceof TypeError && /failed to fetch/i.test(error.message || ''))
                    throw new Error('Network error while loading accounting stats');
                throw error;
            });
    }

    /**
     * Download the accounting statement Excel (relevé comptable) for the
     * current analysis filters.
     *
     * @param {Object} params - Same filter keys as getStats (from, to, …)
     * @returns {Promise<{blob: Blob, filename: string}>}
     */
    exportStatement(params) {
        params = _.pickBy(params, _.identity);

        return this.client.POST('/accountings/export', params, null, {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }).then(async (response) => {
            if (response.ok) {
                const disposition = response.headers.get('Content-Disposition') || '';
                const match = /filename="([^"]+)"/i.exec(disposition);
                return {
                    blob: await response.blob(),
                    filename: match?.[1] || 'ticketack_accounting_stats.xlsx',
                };
            }

            let message = 'Unable to export accounting statement';
            try {
                const json = await response.json();
                message = json?.flash?.error || json?.error || message;
            } catch (e) {
                // ignore parse errors on non-json bodies
            }
            throw new Error(message);
        });
    }
}

const AccountingStatsApi = new AccountingStats();

export default AccountingStatsApi;
